import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  position: relative;\n  width: 100%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  height: ",
        "px;\n  background-color: ",
        ";\n  border-bottom: 1px solid ",
        ";\n  transform: translate3d(0, 0, 0);\n\n  padding-left: 10px;\n  padding-right: 6px;\n\n  .logo {\n    min-width: 50px;\n    height: 100%;\n\n    svg {\n      height: 100%;\n    }\n    image {\n      height: 150%;\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  position: fixed;\n  top: ",
        ";\n  left: 0;\n  transition: top 0.2s;\n  height: ",
        ";\n  width: 100%;\n  z-index: 20;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  height: ",
        ";\n  min-height: ",
        ";\n  max-height: ",
        ";\n  width: 100%;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  position: relative;\n  display: flex;\n  background: url(/newimages/shading.webp) no-repeat;\n  background-size: cover;\n\n  .title {\n    // width: 50%;\n    color: #4d4d4d;\n    margin: 0px auto 45px;\n    text-align: center;\n  }\n  .logo {\n    display: flex;\n    justify-content: center;\n    line-height: 38px;\n    div {\n      display: flex;\n      justify-content: center;\n    }\n  }\n  @media (max-width: 768px) {\n    // background-position: right;\n    // background: url(/newimages/shading.webp) no-repeat;\n    // background-size: cover;\n    .title {\n      width: 90%;\n    }\n    .logo {\n      display: block;\n      div {\n        display: flex;\n        justify-content: center;\n      }\n    }\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  flex-grow: 1;\n  transition: margin-top 0.2s, margin-left 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n  transform: translate3d(0, 0, 0);\n  max-width: 100%;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import throttle from "lodash/throttle";
import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { useTranslation } from "@pancakeswap/localization";
import BottomNav from "../../components/BottomNav";
import { Box } from "../../components/Box";
import { Text } from "../../components/Text";
import Flex from "../../components/Box/Flex";
import Share from "../../../../../src/components/Share";
import { SubMenuItems } from "../../components/SubMenuItems";
import SubMenuItemsHeader from "../../components/SubMenuItems/SubMenuItemsHeader";
import { useMatchBreakpoints } from "../../contexts";
import CakePrice from "../../components/CakePrice/CakePrice";
import Logo from "./components/Logo";
import { MENU_HEIGHT, TOP_BANNER_HEIGHT, TOP_BANNER_HEIGHT_MOBILE } from "./config";
import LangSelector from "../../components/LangSelector/LangSelector";
import { MenuContext } from "./context";
var LazyLoad = require("react-lazyload").default;
var Wrapper = styled.div.withConfig({
    componentId: "sc-a054d83-0"
})(_templateObject());
var StyledNav = styled.nav.withConfig({
    componentId: "sc-a054d83-1"
})(_templateObject1(), MENU_HEIGHT, function(param) {
    var theme = param.theme;
    return theme.nav.background;
}, function(param) {
    var theme = param.theme;
    return theme.colors.cardBorder;
});
var FixedContainer = styled.div.withConfig({
    componentId: "sc-a054d83-2"
})(_templateObject2(), function(param) {
    var showMenu = param.showMenu, height = param.height;
    return showMenu ? 0 : "-".concat(height, "px");
}, function(param) {
    var height = param.height;
    return "".concat(height, "px");
});
var TopBannerContainer = styled.div.withConfig({
    componentId: "sc-a054d83-3"
})(_templateObject3(), function(param) {
    var height = param.height;
    return "".concat(height, "px");
}, function(param) {
    var height = param.height;
    return "".concat(height, "px");
}, function(param) {
    var height = param.height;
    return "".concat(height, "px");
});
var BodyWrapper = styled(Box).withConfig({
    componentId: "sc-a054d83-4"
})(_templateObject4());
var Inner = styled.div.withConfig({
    componentId: "sc-a054d83-5"
})(_templateObject5());
var Menu = function(param) {
    var _linkComponent = param.linkComponent, linkComponent = _linkComponent === void 0 ? "a" : _linkComponent, banner = param.banner, rightSide = param.rightSide, isDark = param.isDark, toggleTheme = param.toggleTheme, currentLang = param.currentLang, setLang = param.setLang, cakePriceUsd = param.cakePriceUsd, links = param.links, subLinks = param.subLinks, footerLinks = param.footerLinks, activeItem = param.activeItem, activeSubItem = param.activeSubItem, langs = param.langs, buyCakeLabel = param.buyCakeLabel, children = param.children;
    var ref = useMatchBreakpoints(), isMobile = ref.isMobile, isMd = ref.isMd;
    var ref1 = useState(true), showMenu = ref1[0], setShowMenu = ref1[1];
    var refPrevOffset = useRef("object" === "undefined" ? 0 : window.pageYOffset);
    var topBannerHeight = isMobile ? TOP_BANNER_HEIGHT_MOBILE : TOP_BANNER_HEIGHT;
    var totalTopMenuHeight = banner ? MENU_HEIGHT + topBannerHeight : MENU_HEIGHT;
    useEffect(function() {
        var handleScroll = function() {
            var currentOffset = window.pageYOffset;
            var isBottomOfPage = window.document.body.clientHeight === currentOffset + window.innerHeight;
            var isTopOfPage = currentOffset === 0;
            // Always show the menu when user reach the top
            if (isTopOfPage) {
                setShowMenu(true);
            } else if (!isBottomOfPage) {
                if (currentOffset < refPrevOffset.current || currentOffset <= totalTopMenuHeight) {
                    // Has scroll up
                    setShowMenu(true);
                } else {
                    // Has scroll down
                    setShowMenu(false);
                }
            }
            refPrevOffset.current = currentOffset;
        };
        var throttledHandleScroll = throttle(handleScroll, 200);
        window.addEventListener("scroll", throttledHandleScroll);
        return function() {
            window.removeEventListener("scroll", throttledHandleScroll);
        };
    }, [
        totalTopMenuHeight
    ]);
    // Find the home link if provided
    var homeLink = links.find(function(link) {
        return link.label === "Home";
    });
    var subLinksWithoutMobile = subLinks === null || subLinks === void 0 ? void 0 : subLinks.filter(function(subLink) {
        return !subLink.isMobileOnly;
    });
    var subLinksMobileOnly = subLinks === null || subLinks === void 0 ? void 0 : subLinks.filter(function(subLink) {
        return subLink.isMobileOnly;
    });
    var t = useTranslation().t;
    var FooterConfig = [
        {
            label: t("Token"),
            href: "/tokenfactory",
            icon: "/images/token.png",
            items: [
                {
                    label: t("Create Token"),
                    href: "/tokenfactory"
                },
                {
                    label: "".concat(t("Create"), "NFT"),
                    href: "/createnft"
                },
                {
                    label: t("Manage Tokens"),
                    href: "/managetokens"
                },
                {
                    label: t("Token Tool"),
                    href: "/tool"
                }, 
            ]
        },
        {
            label: "SOLANA",
            href: "https://sol.gtokentool.com/",
            icon: "/images/solana.png"
        },
        {
            label: "SUI",
            href: "https://sui.gtokentool.com/",
            icon: "/images/chains/sui.png"
        },
        // {
        //   label: "TON",
        //   href: "https://ton.gtokentool.com/",
        //   icon: "/images/chains/ton.png",
        // },
        // {
        //   label: t("Create Presale"),
        //   href: "/fairlaunch",
        //   icon: "/images/presale.webp",
        //   items: [
        //     { label: t("Fairlaunch List"), href: "/fairlaunch" },
        //     { label: t("Pre-sale list"), href: "/launchpad" },
        //     { label: t("Create Fairlaunch"), href: "/fairlaunch/create" },
        //     { label: t("Create Presale"), href: "/launchpad/create" },
        //   ],
        // },
        {
            label: t("Trade"),
            href: "/swap",
            icon: "/images/transaction.png",
            items: [
                {
                    label: t("Swap"),
                    href: "/swap"
                },
                {
                    label: t("Liquidity"),
                    href: "/liquidity"
                }, 
            ]
        },
        {
            label: t("MORE..."),
            icon: "/images/more.png",
            href: "/tokenfactory",
            items: [
                // { label: "竞猜", href: "/fairlaunch" },
                {
                    label: t("Batch Tools"),
                    href: "/sendertoken"
                },
                {
                    label: t("Runes"),
                    href: "/fwlist"
                },
                {
                    label: t("Create IDO"),
                    href: "/idov2"
                },
                {
                    label: t("Create Mining"),
                    href: "/mining"
                },
                {
                    label: t("Market Bot"),
                    href: "/bot"
                },
                {
                    label: t("G Lock"),
                    href: "/createlock"
                }, 
            ]
        }, 
    ];
    var ref2 = useState(false), state = ref2[0], setState = ref2[1];
    var handleCloseShare = function() {
        setState(false);
    };
    var ref3;
    return /*#__PURE__*/ _jsx(MenuContext.Provider, {
        value: {
            linkComponent: linkComponent
        },
        children: /*#__PURE__*/ _jsxs(Wrapper, {
            children: [
                state && /*#__PURE__*/ _jsx(_Fragment, {
                    children: /*#__PURE__*/ _jsx(Share, {
                        onClose: handleCloseShare
                    })
                }),
                /*#__PURE__*/ _jsxs(FixedContainer, {
                    showMenu: true,
                    height: totalTopMenuHeight,
                    children: [
                        banner && /*#__PURE__*/ _jsx(TopBannerContainer, {
                            height: topBannerHeight,
                            children: banner
                        }),
                        /*#__PURE__*/ _jsxs(StyledNav, {
                            children: [
                                /*#__PURE__*/ _jsx(Flex, {
                                    className: "logo",
                                    children: /*#__PURE__*/ _jsx(Logo, {
                                        isDark: isDark,
                                        href: (ref3 = homeLink === null || homeLink === void 0 ? void 0 : homeLink.href) !== null && ref3 !== void 0 ? ref3 : "/"
                                    })
                                }),
                                /*#__PURE__*/ _jsxs(Flex, {
                                    alignItems: "center",
                                    height: "100%",
                                    children: [
                                        /*#__PURE__*/ _jsx(Box, {
                                            mr: "8px",
                                            onClick: function() {
                                                return setState(true);
                                            },
                                            style: {
                                                cursor: "pointer"
                                            },
                                            children: /*#__PURE__*/ _jsx("img", {
                                                src: "/images/share.webp",
                                                alt: "share"
                                            })
                                        }),
                                        !isMobile && !isMd && /*#__PURE__*/ _jsx(Box, {
                                            mr: "5px",
                                            children: /*#__PURE__*/ _jsx(CakePrice, {
                                                showSkeleton: false,
                                                cakePriceUsd: cakePriceUsd
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(Box, {
                                            mr: "5px",
                                            children: /*#__PURE__*/ _jsx(LangSelector, {
                                                currentLang: currentLang,
                                                langs: langs,
                                                setLang: setLang,
                                                buttonScale: "xs",
                                                color: "textSubtle",
                                                hideLanguage: true,
                                                isHide: true
                                            })
                                        }),
                                        rightSide
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                !isMobile && /*#__PURE__*/ _jsx(Flex, {
                    justifyContent: "space-around",
                    style: {
                        borderBottom: "1px solid #4d4d4d"
                    },
                    children: /*#__PURE__*/ _jsx(SubMenuItems, {
                        items: links,
                        mt: "".concat(totalTopMenuHeight + 1, "px"),
                        activeItem: activeSubItem
                    })
                }),
                subLinks && /*#__PURE__*/ _jsx(Flex, {
                    style: {
                        marginTop: "".concat(isMobile ? "40px" : "")
                    },
                    children: /*#__PURE__*/ _jsx(SubMenuItemsHeader, {
                        items: subLinks,
                        mt: "".concat(totalTopMenuHeight + 1, "px"),
                        activeItem: activeSubItem
                    })
                }),
                /*#__PURE__*/ _jsx(BodyWrapper, {
                    pt: !subLinks ? "".concat(totalTopMenuHeight, "px") : "0",
                    children: /*#__PURE__*/ _jsxs(Inner, {
                        isPushed: false,
                        showMenu: showMenu,
                        children: [
                            children,
                            /*#__PURE__*/ _jsxs("div", {
                                className: "title",
                                children: [
                                    /*#__PURE__*/ _jsx("p", {
                                        style: {
                                            color: "#777",
                                            marginTop: "85px",
                                            marginBottom: "30px"
                                        },
                                        children: t("This tool is only used for blockchain learning and testing. Mainland Chinese users are prohibited from using it. If used for illegal activities, it has nothing to do with this site.")
                                    }),
                                    /*#__PURE__*/ _jsx("a", {
                                        href: "https://docs.gtokentool.com/xiang-guan-sheng-ming/mian-ze-sheng-ming",
                                        children: /*#__PURE__*/ _jsx(Text, {
                                            color: "#777",
                                            children: t("Disclaimer")
                                        })
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "logo",
                                        children: [
                                            /*#__PURE__*/ _jsxs("div", {
                                                children: [
                                                    /*#__PURE__*/ _jsx("a", {
                                                        href: "https://t.me/+WYb5xrv-IgQyYWE1",
                                                        target: "_blank",
                                                        rel: "noopener noreferrer nofollow",
                                                        children: /*#__PURE__*/ _jsx(LazyLoad, {
                                                            children: /*#__PURE__*/ _jsx("img", {
                                                                src: "/images/rightnav/telegram.png",
                                                                alt: "https://t.me/+WYb5xrv-IgQyYWE1"
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx("a", {
                                                        href: "https://t.me/+WYb5xrv-IgQyYWE1",
                                                        target: "_blank",
                                                        rel: "noopener noreferrer nofollow",
                                                        color: "#FFFFFF",
                                                        children: t("GTokenTool Chinese community")
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsxs("div", {
                                                children: [
                                                    /*#__PURE__*/ _jsx("a", {
                                                        href: "https://t.me/GToken_EN",
                                                        target: "_blank",
                                                        rel: "noopener noreferrer nofollow",
                                                        color: "#FFFFFF",
                                                        children: /*#__PURE__*/ _jsx(LazyLoad, {
                                                            children: /*#__PURE__*/ _jsx("img", {
                                                                src: "/images/rightnav/telegram.png",
                                                                alt: "https://t.me/GToken_EN"
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx("a", {
                                                        href: "https://t.me/GToken_EN",
                                                        target: "_blank",
                                                        rel: "noopener noreferrer nofollow",
                                                        color: "#FFFFFF",
                                                        children: t("GTokenTool English community")
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsxs("div", {
                                                children: [
                                                    /*#__PURE__*/ _jsx("a", {
                                                        href: "https://x.com/gtokentool",
                                                        target: "_blank",
                                                        rel: "noopener noreferrer nofollow",
                                                        children: /*#__PURE__*/ _jsx(LazyLoad, {
                                                            children: /*#__PURE__*/ _jsx("img", {
                                                                src: "/images/rightnav/x.png",
                                                                alt: "https://x.com/gtokentool"
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx("a", {
                                                        href: "https://x.com/gtokentool",
                                                        target: "_blank",
                                                        rel: "noopener noreferrer nofollow",
                                                        color: "#FFFFFF",
                                                        children: t("Twitter")
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                }),
                isMobile && /*#__PURE__*/ _jsx(BottomNav, {
                    items: FooterConfig,
                    activeItem: activeItem,
                    activeSubItem: activeSubItem
                })
            ]
        })
    });
};
export default Menu;
